import { FillImage } from "components/images";
import { Section } from "components/section";
import React from "react";
import { Button } from "ui/button";
import { Diptych, DiptychColumn } from "ui/diptych";
import diptych1 from "../../../../public/assets/solutions/financial-services/diptych-1.png";
import diptych2 from "../../../../public/assets/solutions/financial-services/diptych-2.png";
import diptych3 from "../../../../public/assets/solutions/financial-services/diptych-3.png";

export function DataSecurityDiptychs() {
  return (
    <Section>
      <DiptychColumn>
        <Diptych
          direction="right"
          title="Keep data in your infrastructure"
          description="Hightouch never stores any of your data. We believe you should maintain control and take advantage of your existing architecture. We operate directly in your data warehouse."
          actions={
            <Button hasRightChevron href="/docs/security/overview#architecture-overview" target="_blank">
              See our product architecture
            </Button>
          }
          media={
            <FillImage
              src={diptych1}
              alt='An abstract illustration that shows a "Data warehouse" - with icons for Snowflake, Databricks, and Google BigQuery - being connected to a "Cloud bucket." The "Cloud bucket" is then connected to "Destinations" - with icons for Facebook, HubSpot, and TikTok.'
            />
          }
        />

        <Diptych
          direction="left"
          title="Enterprise-ready on day one"
          description="Hightouch provides the control and governance capabilities you need to give your marketers safe self-service access."
          actions={
            <Button hasRightChevron href="/platform/reverse-etl#data-governance">
              See our governance features
            </Button>
          }
          media={
            <FillImage
              src={diptych2}
              alt='An abstract illustration showing a large lock icon and a set of features for "Enterpreise teams" and "Hightouch resources". The "Enterprise teams" group includes "Data", "Marketing", and "Operations". The "Hightouch resources" group includes "Audiences", "Models", and "Syncs".'
            />
          }
        />

        <Diptych
          direction="right"
          title="Product security"
          description="Our platform architecture and industry compliance certifications mean that your data is always secure."
          actions={
            <Button hasRightChevron href="/platform/security">
              Learn about data security
            </Button>
          }
          media={
            <FillImage
              src={diptych3}
              alt='An abstract illustration showing four shield icons, each with a corresponding security standard: "SOC 2 Type 2", "AES-256", "HIPAA", and "GDPR".'
            />
          }
        />
      </DiptychColumn>
    </Section>
  );
}
